<div class="host-message">
  <div class="host-message-content" *ngIf="position === 'right'">
    <div class="status">
      <ng-container [ngSwitch]="message?.status">
        <i
          *ngSwitchCase="1"
          nz-icon
          nzType="loading"
          nzTheme="outline"
          class="loading"
        ></i>
        <i
          *ngSwitchCase="2"
          nz-icon
          nzType="check-circle"
          nzTheme="outline"
          class="success"
        ></i>
        <i
          *ngSwitchCase="3"
          nz-icon
          nzType="close-circle"
          nzTheme="outline"
          class="fail"
        ></i>
        <i
          *ngSwitchCase="4"
          nz-icon
          nzType="info-circle"
          nzTheme="outline"
          class="warning"
        ></i>
        <i
          *ngSwitchCase="5"
          nz-icon
          nzType="info-circle"
          nzTheme="outline"
          class="info"
        ></i>
      </ng-container>
    </div>
    <ng-container [ngSwitch]="message?.type">
      <!-- 房源同步 -->
      <ng-container *ngSwitchCase="1">
        <div class="content">
          <div class="title">{{ message?.payload?.title }}</div>
          <div class="desc" [innerHTML]="message?.payload?.desc | html"></div>
        </div>
        <ng-container [ngSwitch]="message?.status">
          <div class="footer" *ngSwitchCase="2">
            <div class="operator" (click)="bindHouse(message?.type)">
              <!-- 立即操作 -->
              {{ "component.message.do_it_now" | translate }}
            </div>
          </div>
          <div class="footer" *ngSwitchCase="3">
            <div
              class="operator"
              (click)="retrySyncHouse(message?.payload.failed_task)"
            >
              <!-- 重试 -->
              {{ "word.retry" | translate }}
            </div>
            <div class="operator" (click)="removeMessage.emit(message?.type)">
              <!-- 关闭 -->
              {{ "word.close" | translate }}
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- 基础价格修改 -->
      <!-- <ng-container *ngSwitchCase="3">
        <div class="content">
          <div class="title">{{ message?.payload?.title }}</div>
          <div
            class="desc"
            [innerHTML]="message?.payload?.desc | html"></div>

        </div>
        <ng-container>
          <div class="footer">
            <div
              class="operator"
              (click)="removeMessage.emit(message?.type)">
              关闭
            </div>
            <div
              class="operator"
              (click)="retrySyncPrice(message.type, message.payload?.taskIds, message.payload?.tasks)"
              *ngIf="message.payload?.hasFailed">
              重试
            </div>
          </div>
        </ng-container>
      </ng-container> -->
      <!-- 周末价格修改 -->
      <!-- <ng-container *ngSwitchCase="4">
        <div class="content">
          <div class="title">{{ message?.payload?.title }}</div>
          <div
            class="desc"
            [innerHTML]="message?.payload?.desc | html"></div>
        </div>
        <ng-container>
          <div class="footer">
            <div
              class="operator"
              (click)="removeMessage.emit(message?.type)">
              关闭
            </div>
          </div>
        </ng-container>
      </ng-container> -->
      <!-- 手动同步订单 -->
      <ng-container *ngSwitchCase="6">
        <div class="content">
          <div class="title">{{ message?.payload?.title }}</div>
          <div class="desc" [innerHTML]="message?.payload?.desc | html"></div>
        </div>
        <ng-container [ngSwitch]="message?.status">
          <div class="footer" *ngSwitchCase="2">
            <div class="operator" (click)="removeMessage.emit(message?.type)">
              <!-- 确定 -->
              {{ "word.confirm" | translate }}
            </div>
          </div>
          <div class="footer" *ngSwitchCase="3">
            <div class="operator" (click)="removeMessage.emit(message?.type)">
              <!-- 关闭 -->
              {{ "word.close" | translate }}
            </div>
            <div class="operator" (click)="retrySyncStatusManual()">
              <!-- 重试 -->
              {{ "word.retry" | translate }}
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- 手动同步房源 -->
      <!-- <ng-container *ngSwitchCase="7">

        <div class="content">
          <div class="title">{{ message?.payload?.title }}</div>
          <div
            class="desc"
            [innerHTML]="message?.payload?.desc | html"></div>
        </div>
        <ng-container [ngSwitch]="message?.status">
          <div
            class="footer"
            *ngSwitchCase="2">
            <div
              class="operator"
              (click)="nowOperate(message?.type)">
              立即操作
            </div>
          </div>
          <div
            class="footer"
            *ngSwitchCase="3">
            <div
              class="operator"
              hostThrottleClick
              (throttleClick)="syncHouseOrigin($event)">
              重新读取
            </div>
            <div
              class="operator"
              (click)="removeMessage.emit(message?.type)">
              关闭
            </div>

          </div>
        </ng-container>
      </ng-container> -->
      <!-- 其他的通知 -->
      <ng-container *ngSwitchDefault>
        <div class="content">
          <div class="title">
            {{ message?.title || message?.payload?.title }}
          </div>
          <div
            class="desc"
            [innerHTML]="message?.content || message?.payload?.desc | html"
          ></div>
        </div>
        <div class="footer">
          <ng-container *ngIf="message?.btns; else others">
            <div
              class="operator"
              *ngFor="let button of message.btns"
              (click)="
                button.cb && button.cb(); removeMessage.emit(message?.type)
              "
            >
              {{ button.text }}
            </div>
          </ng-container>
          <ng-template #others>
            <div class="operator" (click)="message?.payload?.behavior?.onOk()">
              <!-- 查看 -->
              {{ "word.view" | translate }}
            </div>
            <div class="operator" (click)="removeMessage.emit(message?.type)">
              <!-- 关闭 -->
              {{ "word.close" | translate }}
            </div>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- 中间的弹窗 -->
  <div class="host-message-content right" *ngIf="position === 'center'">
    <div class="status">
      <i nz-icon nzType="cloud-sync" nzTheme="outline"></i>
    </div>
    <div class="content">
      <div class="title">{{ message?.payload?.title }}</div>
      <div class="desc" [innerHTML]="message?.payload?.desc | html"></div>
    </div>
    <div class="close" (click)="hideMessage.emit(message)">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </div>
  </div>
</div>
